<p *ngIf="!value">N/A</p>

<button
    *ngIf="value && !isDisabled"
    mat-button
    [matMenuTriggerFor]="popupMenu"
    (menuOpened)="onPopupOpened()"
    class="px-0"
    #menuTrigger="matMenuTrigger"
    [class.active]="menuTrigger.menuOpen"
>
    <mat-icon class="s-16 mr-2" svgIcon="calendar"></mat-icon>

    <span>{{ value.title }}</span>
    <mat-icon class="s-12 ml-4" svgIcon="dropdown" iconPositionEnd></mat-icon>
</button>

<button *ngIf="isDisabled" mat-button class="disabled px-0">
    <mat-icon class="s-16 mr-2" svgIcon="calendar"></mat-icon>
    {{ value?.title }}
    <mat-icon class="s-20 mr-0">arrow_drop_down</mat-icon>
</button>

<mat-menu
    #popupMenu="matMenu"
    [overlapTrigger]="false"
    xPosition="after"
    class="select-period-dropdown"
    (click)="$event.stopPropagation()"
>
    <div fxLayout="row" fxLayoutAlign="start" class="content" (click)="$event.stopPropagation()">
        <div class="row-predefined">
            <ng-container *ngFor="let item of predefinedItems">
                <button
                    mat-button
                    fxLayout="row"
                    fxLayoutAlign="start"
                    class="h3 pl-25"
                    (click)="onSelectPredefined(item, $event)"
                    [disabled]="item.disabled"
                    [ngClass]="{ selected: item.id === selectedPeriod.id, disabled: !isPeriodSelectable(item) }"
                >
                    {{ item.title }}
                </button>
            </ng-container>
        </div>
        <div class="row-calendar" fxFlex>
            <month-picker
                [minDate]="calandarMinDate"
                [maxDate]="calandarMaxDate"
                [startDate]="calandarStartDate"
                [endDate]="calandarEndDate"
                [selectableMonthsDates]="selectableMonthsDates"
                [maxSelectableMonthsCount]="periodMaxMonths"
                (monthRangeSelected)="onCalendarSelect($event)"
            >
            </month-picker>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" class="footer" (click)="$event.stopPropagation()">
        <!-- button
            mat-raised-button
            type="button"
            color=""
            class="ml-16 btn-cancel"
            (click)="onBtnCancelClick()"
        >
            <span>Cancel</span>
        </button -->

        <button mat-raised-button type="button" color="accent" class="ml-16 btn-apply" (click)="onBtnApplyClick()">
            <span>Apply</span>
        </button>
    </div>
</mat-menu>
